import React, { Component } from "react";
class CageTheElephant extends Component {
  render() {
    return (
      <section className="col-7 nested">
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            I love indie rock. But they don't always have the best websites. I
            think Cage The Elephant could use a bit of a makeover to their
            official website. I want to make an album flow that is really
            simple, yet aesthetic.
          </p>
          <p className="reflections col-2">
            An interesting indie rock band website though -
            <a
              className="social-media-link"
              href="https://opensource.glassanimals.com/"
              target="blank"
            >
              Glass Animals
            </a>
          </p>
        </div>

        <h2 className="large-spacer-top col-5">Project Overview</h2>

        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>
            <span role="img" aria-label="sparkle">
              📱
            </span>{" "}
            The Product
          </strong>{" "}
        </h3>
        <br></br>
        <p className="large-paragraph medium-spacer-bottom col-5">
          <div className="text-group">
            We are creating an album listening and ordering flow for Cage The
            Elephant. This flow will simplify the whole process by leading the
            user intuitively towards listening to and buying an album, should
            they want to.
          </div>
        </p>
        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>
            <span role="img" aria-label="sparkle">
              ⌛
            </span>{" "}
            Project Duration
          </strong>{" "}
        </h3>
        <br></br>
        <p className="large-paragraph medium-spacer-bottom col-5">
          <div className="text-group">August 2022 – September 2022</div>
        </p>
        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>
            <span role="img" aria-label="sparkle">
              ⚠️
            </span>{" "}
            The Problem
          </strong>{" "}
        </h3>
        <br></br>
        <p className="large-paragraph medium-spacer-bottom col-5">
          <div className="text-group">
            Before purchasing an album, users want to listen to some of the
            tracks from the album
          </div>
        </p>
        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>
            <span role="img" aria-label="sparkle">
              🏆
            </span>{" "}
            The Goal
          </strong>{" "}
        </h3>
        <br></br>
        <p className="large-paragraph medium-spacer-bottom col-5">
          <div className="text-group">
            Design an album listening and ordering flow that allows the user to
            both listen to and buy albums made by the band – Cage The Elephant
          </div>
        </p>
        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>
            <span role="img" aria-label="sparkle">
              ⚙️
            </span>{" "}
            My Role
          </strong>{" "}
        </h3>
        <br></br>
        <p className="large-paragraph medium-spacer-bottom col-5">
          <div className="text-group">
            UX designer designing the album listening and ordering flow for Cage
            The Elephant, overseeing the project from start to finish
          </div>
        </p>
        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>
            <span role="img" aria-label="sparkle">
              ✍️
            </span>{" "}
            Resposibilities
          </strong>{" "}
        </h3>
        <br></br>
        <p className="large-paragraph medium-spacer-bottom col-5">
          <div className="text-group">
            Paper and digital wireframing, low and high-fidelity prototyping and
            iterating on designs.
          </div>
        </p>

        <h2 className="large-spacer-top col-5">Why the Re-design?</h2>
        <br></br>

        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            <span>
              <h3>01</h3>
              <span>
                <h4>Complicated User Journey</h4>{" "}
              </span>
              The original website is too busy to understand where to go to
              complete a single task without trial and error
            </span>
            <br></br>
            <br></br>
            <span>
              <h3>02</h3>{" "}
              <span>
                <h4>Low Retention Rate</h4>{" "}
              </span>
              Band websites are usually too boring and turn users away as they
              don’t catch the user’s attention.
            </span>
            <br></br>
            <br></br>
            <span>
              <h3>03</h3>{" "}
              <span>
                <h4>Listening Experience</h4>{" "}
              </span>
              A lot of these sites, including Cage The Elephant, don’t let the
              users listen to their music on the site itself and redirect users
              to other streaming sites
            </span>
          </p>
          <p className="reflections col-2">
            All this and a bit of simplification of the existing Cage The
            Elephant Website
          </p>
        </div>
        <br></br>
        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="OG site"
              src={require("../assets/images/cagetheelephant/ctg_site.gif")}
            />
          </div>
        </div>
        <br></br>
        <h1 className="large-spacer-top col-5">Site Map</h1>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            Since this is a complete redesign, I wanted to include the least
            amount of steps for the user. For the very first iteration, we'd
            like the user to have only 2 options - <strong>Listen</strong> and{" "}
            <strong>Buy</strong>
          </p>
          <p className="reflections col-2">Mo' choices, Mo' problems</p>
        </div>
        <br></br>
        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Site map"
              src={require("../assets/images/cagetheelephant/sitemap.png")}
            />
          </div>
        </div>
        <br></br>
        <h1 className="large-spacer-top col-5">Design</h1>

        <h2 className="large-spacer-top col-5">Trial and Error on paper</h2>
        <br></br>
        <br></br>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Home page"
              src={require("../assets/images/cagetheelephant/home_iters.png")}
            />
          </div>
        </div>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            I went through 5 different iterations of the home page before
            settling on the final one.
          </p>
        </div>
        <br></br>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Home page"
              src={require("../assets/images/cagetheelephant/paper_home.png")}
            />
          </div>
        </div>
        <br></br>
        <h2 className="large-spacer-top col-5">Final designs</h2>
        <br></br>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Home page"
              src={require("../assets/images/cagetheelephant/home.gif")}
            />
          </div>
          <p className="reflections col-2">
            Music plays when you hit unmute 🤩
          </p>
        </div>
        <br></br>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Navbar"
              src={require("../assets/images/cagetheelephant/nav.gif")}
            />
          </div>
          <p className="reflections col-2">Easy Navigation</p>
        </div>
        <br></br>

        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Listen"
              src={require("../assets/images/cagetheelephant/listen.jpg")}
            />
          </div>
        </div>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            After designing the Home, navigation and Album display pages,
            individual listen/buy page design was needed for each album
          </p>
          <p className="reflections col-2">
            Latest Cage The Elephant album - Social Cues
          </p>
        </div>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Social Cues"
              src={require("../assets/images/cagetheelephant/album_listen.jpg")}
            />
          </div>
        </div>
        <br></br>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Social Cues"
              src={require("../assets/images/cagetheelephant/album_buy.jpg")}
            />
          </div>
        </div>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            And then, finally, track and cart
          </p>
        </div>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Tracks"
              src={require("../assets/images/cagetheelephant/track.jpg")}
            />
          </div>
        </div>
        <br></br>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Signing Up Use Case Diagram"
              src={require("../assets/images/cagetheelephant/cart.gif")}
            />
          </div>
        </div>
        <br></br>
        <h2 className="large-spacer-top col-5">All Mockups</h2>
        <br></br>
        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Mockups"
              src={require("../assets/images/cagetheelephant/web_mockup.jpg")}
            />
          </div>
          <br></br>
        </div>
        <h2 className="project-subheading medium-spacer-top col-5">
          <strong> Accessibility Considerations </strong>
        </h2>
        <br></br>
        <div className="text-group">
          <ul className="text-list medium-spacer-bottom col-5">
            <li>
              Provided Navigation bar for the user to go back and forth from
              anywhere in the website.
            </li>
            <li>
              Included toggle switch on home page to play and pause music. Same
              at individual track page to pause/play music video.
            </li>
            <li>
              Provided options in the cart to change item quantity and album
              format.
            </li>
          </ul>
        </div>
        <h1 className="large-spacer-top col-5">Going Forward</h1>
        <br></br>

        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>
            <span role="img" aria-label="sparkle">
              🔮
            </span>{" "}
            Future Work
          </strong>{" "}
        </h3>
        <br></br>
        <div className="text-group">
          <ul className="text-list medium-spacer-bottom col-5">
            <li>
              We could also include Cage The Elephant merchandise at a later
              stage.
            </li>
            <li>
              A payment portal can be included and album ordering can be
              streamlined further
            </li>
            <li>
              Every time a new album comes out, promotional design can be
              included to pique user interest.
            </li>
          </ul>
        </div>
      </section>
    );
  }
}

export default CageTheElephant;
